var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShieldTrustnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1216,
    height: 296,
    viewBox: "0 0 1216 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.25 134.315C376.25 156.797 359.787 179.522 323.033 179.522C310.007 179.655 297.171 176.388 285.794 170.043L280.812 166.701L289.803 136.867L298.794 142.396C306.502 147.04 315.311 149.537 324.309 149.627C330.02 149.627 343.142 148.29 343.142 135.773C343.142 129.697 341.744 124.532 324.188 117.544C297.761 108.126 284.882 93.7257 284.882 73.4312C284.7 48.5187 305.659 30.2901 334.394 30.2901C345.677 29.927 356.866 32.4581 366.895 37.6423L372.97 40.9234L362.946 70.2108L354.441 65.5929C348.119 62.2518 341.057 60.559 333.908 60.6711C318.538 60.6711 317.748 69.9677 317.748 71.7906C317.748 77.5022 319.206 81.7556 338.16 89.1078C348.601 92.5556 358.089 98.4034 365.862 106.182C372.827 113.866 376.549 123.947 376.25 134.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.781 30.2901C437.646 30.1795 428.592 32.0068 420.215 35.6516C411.838 39.2964 404.328 44.6759 398.181 51.4353C385.166 66.6153 378.335 86.1363 379.045 106.121C379.045 149.384 406.2 179.583 445.08 179.583C478.918 179.583 512.999 156.068 512.999 103.63C513.665 84.6292 507.355 66.0415 495.26 51.3746C489.228 44.5084 481.756 39.0586 473.376 35.4139C464.996 31.7693 455.915 30.0197 446.781 30.2901ZM445.87 149.688C430.014 149.688 412.883 135.895 412.883 105.635C412.883 72.0337 430.743 60.0635 446.052 60.0635C468.712 60.0635 478.979 83.0316 478.979 104.298C478.979 126.902 468.773 149.688 445.87 149.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.855 34.4827H521.99V179.522H609.895V149.323H554.855V34.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.835 34.4827H615.97V179.522H648.835V34.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.63 50.5846C753.447 38.4322 734.614 32.356 708.917 32.356C696.714 32.3552 684.528 33.2897 672.467 35.151L665.481 36.3663V177.091L672.649 177.942C682.981 179.039 693.364 179.566 703.753 179.522C731.091 179.522 752.779 172.291 766.387 158.62C773.464 151.206 778.969 142.438 782.571 132.841C786.173 123.245 787.797 113.019 787.345 102.779C787.824 93.1037 786.223 83.4379 782.649 74.434C779.075 65.4301 773.613 57.2975 766.63 50.5846ZM707.034 149.87C705.454 149.87 701.87 149.87 698.347 149.87V62.3724C702.121 61.9938 705.913 61.8113 709.707 61.8256C724.712 61.8256 736.012 65.5928 743.423 73.0058C747.092 77.1194 749.897 81.9285 751.671 87.1476C753.445 92.3666 754.152 97.8891 753.751 103.387C753.568 133.586 737.591 149.87 707.034 149.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.342 34.3003H855.629C883.756 34.3003 901.799 50.4023 901.799 75.9831C901.799 101.564 883.574 117.909 855.629 117.909H816.323V177.942H811.342V34.3003ZM816.323 38.979V113.413H855.325C880.718 113.413 896.817 99.1942 896.817 76.1654C896.817 53.1973 880.718 39.1613 855.325 39.1613L816.323 38.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.21 74.4034H927.07V95.1841C928.411 88.7132 931.992 82.9229 937.182 78.8327C942.371 74.7425 948.837 72.6146 955.441 72.8236C959.025 72.7574 962.584 73.4404 965.89 74.8288V79.872C962.412 78.1842 958.575 77.3707 954.712 77.5023C937.641 77.5023 927.07 92.389 927.07 113.291V177.942H922.21V74.4034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.287 126.173C967.287 93.4219 985.512 73.0059 1012.85 73.0059C1040.19 73.0059 1058.53 93.3004 1058.53 126.173C1058.53 158.984 1040.31 179.522 1012.85 179.522C985.391 179.522 967.287 158.923 967.287 126.173ZM1053.67 126.173C1053.67 96.1562 1037.03 77.563 1012.85 77.563C988.671 77.563 972.269 96.2777 972.269 126.173C972.269 156.128 988.367 174.782 1012.85 174.782C1037.33 174.782 1053.67 156.128 1053.67 126.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.05 126.173C1071.05 93.4219 1089.27 73.0059 1116.67 73.0059C1144.07 73.0059 1162.36 93.3004 1162.36 126.173C1162.36 158.984 1144.13 179.522 1116.67 179.522C1089.21 179.522 1071.05 158.923 1071.05 126.173ZM1157.43 126.173C1157.43 96.1562 1140.85 77.563 1116.67 77.563C1092.49 77.563 1076.03 96.2777 1076.03 126.173C1076.03 156.128 1092.19 174.782 1116.67 174.782C1141.15 174.782 1157.43 156.128 1157.43 126.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.89 78.8999H1170.5V74.4035H1184.89V55.8711C1184.89 39.5868 1193.76 32.7207 1207.49 32.7207C1210.07 32.7423 1212.63 33.0274 1215.15 33.5714V37.9462C1212.69 37.4107 1210.19 37.1458 1207.67 37.1563C1196.74 37.1563 1189.88 42.4426 1189.88 56.4787V74.7073H1214.18V78.8999H1189.88V177.942H1184.89V78.8999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.689 33.2942L126.143 262.975C105.065 250.299 86.525 233.816 71.4677 214.365C73.6547 214.365 75.9025 214.669 78.0287 214.669C110.955 214.669 125.657 194.375 125.657 174.262C125.967 164.911 122.634 155.805 116.362 148.864C109.299 141.951 100.702 136.809 91.2722 133.855C74.323 127.232 73.0472 123.465 73.0472 118.422C73.0472 116.721 73.8977 108.639 87.6272 108.032C96.2537 107.606 102.875 108.032 109.619 108.032H121.769L122.315 82.0254H118.184C111.38 82.0254 103.24 82.0254 87.8095 82.0254C61.9907 82.0254 43.2797 98.2489 43.2797 120.609C43.2797 138.838 54.7615 151.659 78.454 160.044C94.1882 166.12 95.4032 170.738 95.4032 176.146C95.4032 187.326 83.6177 188.298 78.5755 188.298C70.5226 188.234 62.6344 186.009 55.7335 181.858L47.7145 176.814V177.543C31.4543 143.529 25.0159 105.649 29.125 68.1716C29.125 68.1716 83.8 68.9008 126.75 33.4157C126.568 33.1727 126.629 33.1727 126.689 33.2942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.75 2.48763V16.2806C122.41 19.8994 117.867 23.267 113.142 26.3671C83.6495 45.0142 49.6669 55.3433 14.7879 56.2621C9.49343 103.943 19.2434 152.087 42.6722 193.949C45.9527 200.025 49.4154 205.372 52.9997 210.598C68.5558 233.194 87.798 253.016 109.922 269.233L113.264 271.664C117.363 274.734 121.644 277.554 126.082 280.11V295.908C126.082 295.908 -15.2226 219.955 1.5444 45.2641C1.5444 45.2641 72.0144 46.1756 126.75 0.604004V2.48763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.418 186.111C229.418 185.564 230.025 185.017 230.268 184.47H229.418V186.111Z",
    fill: "url(#paint0_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.973 198.992H222.492C223.646 197.048 224.74 195.103 225.833 192.916H220.913L220.973 198.992Z",
    fill: "url(#paint1_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.235 201.839L212.403 201.899L212.463 207.732L218.295 207.672L218.235 201.839Z",
    fill: "url(#paint2_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.698 210.494L203.866 210.554L203.926 216.387L209.758 216.327L209.698 210.494Z",
    fill: "url(#paint3_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.222 219.209L195.39 219.27L195.45 225.102L201.282 225.042L201.222 219.209Z",
    fill: "url(#paint4_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.664 227.854H188.108L186.832 229.313V233.748H192.907L192.664 227.854Z",
    fill: "url(#paint5_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.159 236.604H180.392L178.327 238.791V242.498H184.402L184.159 236.604Z",
    fill: "url(#paint6_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 245.293H171.887L169.822 247.359V251.187H175.897L175.654 245.293Z",
    fill: "url(#paint7_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.149 253.982L162.532 254.043L161.256 255.076L161.317 259.876L167.21 259.815L167.149 253.982Z",
    fill: "url(#paint8_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.6 262.726L152.769 262.786L152.829 268.619L158.66 268.559L158.6 262.726Z",
    fill: "url(#paint9_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.064 271.381L144.232 271.441L144.292 277.274L150.124 277.214L150.064 271.381Z",
    fill: "url(#paint10_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.527 280.097L135.695 280.157L135.755 285.99L141.587 285.93L141.527 280.097Z",
    fill: "url(#paint11_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.722 288.799V294.875H128.694C129.545 294.389 131.003 293.538 132.886 292.323V288.981L127.722 288.799Z",
    fill: "url(#paint12_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.801 164.662H239.077C239.867 162.717 240.596 160.712 241.325 158.585H237.74L237.801 164.662Z",
    fill: "url(#paint13_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.129 167.154L229.176 167.215L229.238 173.169L235.191 173.108L235.129 167.154Z",
    fill: "url(#paint14_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.654 175.808L220.7 175.87L220.762 181.824L226.715 181.763L226.654 175.808Z",
    fill: "url(#paint15_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.268 184.531L214.048 190.607H218.179V184.531H217.268Z",
    fill: "url(#paint16_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.674 199.174V198.02L208.945 199.174H209.674Z",
    fill: "url(#paint17_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.084 219.348V220.198L178.813 219.348H178.084Z",
    fill: "url(#paint18_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.579 228.097V229.373L170.916 228.037L169.579 228.097Z",
    fill: "url(#paint19_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.074 236.786V237.576L161.985 236.726L161.074 236.786Z",
    fill: "url(#paint20_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.82 277.497H133.007V276.282L130.82 277.497Z",
    fill: "url(#paint21_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.063 138.595H247.582C248.129 136.59 248.615 134.584 249.101 132.519H246.002L246.063 138.595Z",
    fill: "url(#paint22_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.549 141.184L237.474 141.247L237.537 147.322L243.612 147.26L243.549 141.184Z",
    fill: "url(#paint23_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.726 149.896C231.058 151.962 230.39 153.968 229.661 155.973H235.067V149.896H231.726Z",
    fill: "url(#paint24_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.791 175.963H203.417V182.04H204.571C205.665 180.095 206.697 178.029 207.791 175.963Z",
    fill: "url(#paint25_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.987 188.541L200.926 184.652L194.912 184.713L194.972 190.789L199.65 190.729L200.987 188.541Z",
    fill: "url(#paint26_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.452 193.355L186.377 193.418L186.44 199.494L192.514 199.431L192.452 193.355Z",
    fill: "url(#paint27_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.915 202.071L177.84 202.133L177.903 208.209L183.978 208.147L183.915 202.071Z",
    fill: "url(#paint28_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.439 210.726L169.364 210.788L169.427 216.864L175.501 216.801L175.439 210.726Z",
    fill: "url(#paint29_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.842 219.441L160.767 219.504L160.83 225.58L166.904 225.517L166.842 219.441Z",
    fill: "url(#paint30_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.366 228.157L152.292 228.219L152.354 234.295L158.429 234.233L158.366 228.157Z",
    fill: "url(#paint31_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83 236.811L143.755 236.874L143.817 242.95L149.892 242.887L149.83 236.811Z",
    fill: "url(#paint32_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.353 245.527L135.279 245.589L135.341 251.665L141.416 251.603L141.353 245.527Z",
    fill: "url(#paint33_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.825 259.268V254.225H127.722V260.301H131.003C131.63 259.993 132.239 259.648 132.825 259.268Z",
    fill: "url(#paint34_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.76 115.262V121.338H251.47C251.47 120.609 251.47 119.88 251.895 119.09V115.201L245.76 115.262Z",
    fill: "url(#paint35_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.451 123.89H238.409L237.315 129.055V130.027H243.39L243.451 123.89Z",
    fill: "url(#paint36_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.244 141.329V143.82L220.973 141.329H220.244Z",
    fill: "url(#paint37_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.875 151.416V149.957H211.8V156.033H216.235L217.875 151.416Z",
    fill: "url(#paint38_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.347 158.67L203.211 158.734L203.274 164.87L209.41 164.807L209.347 158.67Z",
    fill: "url(#paint39_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.81 167.386L194.674 167.449L194.737 173.586L200.873 173.522L200.81 167.386Z",
    fill: "url(#paint40_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.273 176.041L186.138 176.104L186.201 182.241L192.336 182.178L192.273 176.041Z",
    fill: "url(#paint41_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.737 184.756L177.601 184.82L177.664 190.956L183.8 190.893L183.737 184.756Z",
    fill: "url(#paint42_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.261 193.472L169.126 193.535L169.189 199.672L175.325 199.608L175.261 193.472Z",
    fill: "url(#paint43_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.725 202.187L160.589 202.25L160.653 208.387L166.788 208.324L166.725 202.187Z",
    fill: "url(#paint44_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.28 217.039L152.144 217.099L152.083 211.995H158.219L158.28 217.039Z",
    fill: "url(#paint45_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.595 219.614L143.459 219.675L143.52 225.812L149.656 225.751L149.595 219.614Z",
    fill: "url(#paint46_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.176 228.273L135.041 228.336L135.104 234.473L141.239 234.41L141.176 228.273Z",
    fill: "url(#paint47_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.704 236.969L127.965 237.03V243.166L132.704 243.106V236.969Z",
    fill: "url(#paint48_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.143 95.5144H255.297C255.297 93.4485 255.662 91.3826 255.783 89.4382H254.082L254.143 95.5144Z",
    fill: "url(#paint49_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.79 97.8994L245.533 97.9639L245.598 104.222L251.855 104.158L251.79 97.8994Z",
    fill: "url(#paint50_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.142 106.634C240.839 108.76 240.596 110.826 240.292 112.71H243.147V106.634H241.142Z",
    fill: "url(#paint51_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.922 124.012H220.001V130.088H223.586C224.132 128.204 224.558 126.138 224.922 124.012Z",
    fill: "url(#paint52_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.815 138.959H213.927C214.661 136.979 215.25 134.949 215.688 132.883H217.754L217.815 138.959Z",
    fill: "url(#paint53_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.239 165.087H186.164V163.932C188.351 163.203 190.376 162.413 192.239 161.563V165.087Z",
    fill: "url(#paint54_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.62 167.502L177.363 167.566L177.427 173.825L183.684 173.76L183.62 167.502Z",
    fill: "url(#paint55_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.144 176.157L168.887 176.221L168.952 182.479L175.209 182.415L175.144 176.157Z",
    fill: "url(#paint56_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.608 184.933L160.351 184.997L160.416 191.255L166.672 191.191L166.608 184.933Z",
    fill: "url(#paint57_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.148 217.282L134.891 217.342L134.83 211.874L141.087 211.935L141.148 217.282Z",
    fill: "url(#paint58_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.522 219.712H127.965V225.971H132.582L132.522 219.712Z",
    fill: "url(#paint59_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.9 78.3794H256.391C256.391 76.3135 256.391 74.1868 256.391 72.3032H253.718L253.9 78.3794Z",
    fill: "url(#paint60_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.674 80.6452L245.295 80.7109L245.361 87.0906L251.739 87.0249L251.674 80.6452Z",
    fill: "url(#paint61_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.54 89.3774C242.54 91.5041 242.54 93.6308 242.175 95.4536H243.147V89.3167L242.54 89.3774Z",
    fill: "url(#paint62_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.185 106.731L219.807 106.796L219.873 113.176L226.251 113.11L226.185 106.731Z",
    fill: "url(#paint63_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.693 122.128H216.66C216.654 119.992 216.492 117.86 216.174 115.748H217.632L217.693 122.128Z",
    fill: "url(#paint64_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.541 174.019L160.345 174.08L160.405 167.7L166.48 167.639L166.541 174.019Z",
    fill: "url(#paint65_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.76 202.456V208.836H127.965V202.456H130.76Z",
    fill: "url(#paint66_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.148 54.7432H253.596V61.3662H256.33C256.33 59.0573 256.269 56.8698 256.148 54.7432Z",
    fill: "url(#paint67_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.551 63.469L245.112 63.5334L245.176 69.9742L251.616 69.9098L251.551 63.469Z",
    fill: "url(#paint68_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.008 89.4769L219.568 89.5432L219.635 95.9837L226.074 95.9173L226.008 89.4769Z",
    fill: "url(#paint69_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.571 104.629H212.772C212.218 103.377 211.589 102.16 210.889 100.983V98.188H217.328L217.571 104.629Z",
    fill: "url(#paint70_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.257 124.316C187.172 126.547 186.699 128.747 185.86 130.817H185.556V124.316H187.257Z",
    fill: "url(#paint71_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43 134.584C181.645 136.457 179.436 137.874 176.99 138.716V133.005H183.49L183.43 134.584Z",
    fill: "url(#paint72_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.881 185.199L130.821 191.64H127.965L128.026 185.199H130.881Z",
    fill: "url(#paint73_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.439 46.076L244.878 46.1436L244.946 52.7055L251.507 52.6379L251.439 46.076Z",
    fill: "url(#paint74_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.871 54.8037C241.871 56.9911 242.236 59.1786 242.357 61.366H243.147V54.8037H241.871Z",
    fill: "url(#paint75_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.821 72.2935L219.26 72.3591L219.325 78.9214L225.886 78.8558L225.821 72.2935Z",
    fill: "url(#paint76_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.354 80.8773L210.793 80.9448L210.861 87.5068L217.422 87.4392L217.354 80.8773Z",
    fill: "url(#paint77_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.884 96.1827H207.487C206.491 95.054 205.414 93.998 204.267 93.0231C203.641 92.4084 202.971 91.8398 202.262 91.3217V89.6812H208.823L208.884 96.1827Z",
    fill: "url(#paint78_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.269 115.739L176.708 115.807L176.776 122.369L183.337 122.301L183.269 115.739Z",
    fill: "url(#paint79_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.766 124.452L168.205 124.518L168.27 131.08L174.831 131.015L174.766 124.452Z",
    fill: "url(#paint80_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.256 133.109L159.696 133.177L159.763 139.739L166.324 139.671L166.256 133.109Z",
    fill: "url(#paint81_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.942 167.882V174.444L128.026 174.505V167.943L130.942 167.882Z",
    fill: "url(#paint82_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.147 40.6462L236.465 39.9778V44.2919H243.086L243.147 40.6462Z",
    fill: "url(#paint83_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.278 46.2363L227.595 46.2971L227.656 51.5834L234.338 52.1302L234.278 46.2363Z",
    fill: "url(#paint84_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.207 63.7358H216.296H210.585V70.4197H217.207V63.7358Z",
    fill: "url(#paint85_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.701 72.3384L202.019 72.4072L202.087 79.0907L208.77 79.0219L208.701 72.3384Z",
    fill: "url(#paint86_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.258 87.676H196.734C195.711 87.1093 194.657 86.6021 193.575 86.157V81.053H200.258V87.676Z",
    fill: "url(#paint87_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.621 108.335L174.682 113.804L168.06 113.865L168 107.728L174.621 108.335Z",
    fill: "url(#paint88_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.14 115.855L159.458 115.924L159.526 122.607L166.208 122.538L166.14 115.855Z",
    fill: "url(#paint89_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.664 124.51L150.982 124.578L151.051 131.262L157.733 131.193L157.664 124.51Z",
    fill: "url(#paint90_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.066 133.226L142.384 133.294L142.453 139.978L149.135 139.909L149.066 133.226Z",
    fill: "url(#paint91_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.063 150.625L131.003 157.309H128.026V150.686L131.063 150.625Z",
    fill: "url(#paint92_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.712 44.4133L225.651 38.4586L221.399 37.7295H218.847L218.908 44.4741L225.712 44.4133Z",
    fill: "url(#paint93_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.085 46.3579H210.342V49.2137L217.146 50.3682L217.085 46.3579Z",
    fill: "url(#paint94_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.898 61.3662V61.67H203.234L201.898 61.3662Z",
    fill: "url(#paint95_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.047 63.7391L193.304 63.8086L193.374 70.5528L200.117 70.4834L200.047 63.7391Z",
    fill: "url(#paint96_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51 72.4545L184.768 72.5239L184.837 79.2682L191.58 79.1987L191.51 72.4545Z",
    fill: "url(#paint97_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.065 82.9367C180.878 82.5114 178.63 82.1468 176.261 81.9037V81.2354H183.004L183.065 82.9367Z",
    fill: "url(#paint98_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55 113.986L150.746 114.108L150.686 107.606L157.49 107.667L157.55 113.986Z",
    fill: "url(#paint99_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.95 115.971L142.207 116.041L142.276 122.785L149.019 122.715L148.95 115.971Z",
    fill: "url(#paint100_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.352 124.626L133.609 124.696L133.679 131.44L140.422 131.371L140.352 124.626Z",
    fill: "url(#paint101_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.914 133.369H128.026V140.114H131.975L131.914 133.369Z",
    fill: "url(#paint102_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.076 35.9675L210.16 35.3599V36.0282L213.076 35.9675Z",
    fill: "url(#paint103_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.467 37.8297L201.603 37.9004L201.673 44.7661L208.538 44.6954L208.467 37.8297Z",
    fill: "url(#paint104_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.645 62.0953H191.51V59.4218L184.645 57.6597V62.0953Z",
    fill: "url(#paint105_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.918 63.9156L176.053 63.9863L176.124 70.8521L182.988 70.7814L182.918 63.9156Z",
    fill: "url(#paint106_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.381 72.5704L167.517 72.6411L167.587 79.5069L174.452 79.4362L174.381 72.5704Z",
    fill: "url(#paint107_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.873 81.2959V81.4174L159.008 81.3567L165.873 81.2959Z",
    fill: "url(#paint108_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.358 114.229L133.493 114.29L133.433 107.606H140.297L140.358 114.229Z",
    fill: "url(#paint109_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.792 116.052L128.026 116.113V122.979L131.853 122.918L131.792 116.052Z",
    fill: "url(#paint110_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.893 36.1499V32.6257C197.584 31.9573 195.276 31.2889 192.907 30.499V36.5752L199.893 36.1499Z",
    fill: "url(#paint111_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.341 37.9729V42.2262L191.328 44.4137L191.267 37.9121L184.341 37.9729Z",
    fill: "url(#paint112_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.257 55.3706L167.271 55.4404L167.341 62.4281L174.327 62.3582L174.257 55.3706Z",
    fill: "url(#paint113_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.789 64.0313L158.803 64.1033L158.875 71.0905L165.861 71.0186L165.789 64.0313Z",
    fill: "url(#paint114_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 72.6866L150.205 72.7585L150.277 79.7458L157.263 79.6739L157.191 72.6866Z",
    fill: "url(#paint115_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.306 98.7954V105.783H128.086V98.8562L131.306 98.7954Z",
    fill: "url(#paint116_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.623 29.3469L175.577 29.4194L175.649 36.4675L182.696 36.3949L182.623 29.3469Z",
    fill: "url(#paint117_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.92 38.0334L174.135 38.5195V38.0334H172.92Z",
    fill: "url(#paint118_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.583 53.8924H165.691V51.0366C163.382 50.0644 161.013 49.0314 158.583 47.877V53.8924Z",
    fill: "url(#paint119_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.074 55.4323L150.027 55.5049L150.1 62.5529L157.147 62.4803L157.074 55.4323Z",
    fill: "url(#paint120_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.538 64.1481L141.491 64.2207L141.564 71.2687L148.61 71.1962L148.538 64.1481Z",
    fill: "url(#paint121_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.001 72.8029L132.955 72.8755L133.027 79.9235L140.074 79.8509L140.001 72.8029Z",
    fill: "url(#paint122_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.428 81.5391L131.367 88.5875L128.086 88.6482V81.5391H131.428Z",
    fill: "url(#paint123_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.075 27.9471V23.4507L168 20.8379H166.663V28.0078L174.075 27.9471Z",
    fill: "url(#paint124_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.097 29.5266V31.4102C160.466 32.6255 162.896 33.7799 165.266 34.8736V29.4658L158.097 29.5266Z",
    fill: "url(#paint125_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.835 45.3858H153.48L149.835 43.4414V45.3858Z",
    fill: "url(#paint126_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.482 46.8935L141.313 46.9673L141.387 54.1368L148.555 54.063L148.482 46.8935Z",
    fill: "url(#paint127_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.884 55.5487L132.716 55.6226L132.79 62.7921L139.958 62.7183L139.884 55.5487Z",
    fill: "url(#paint128_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.367 64.2827H128.086V71.4526L131.488 71.3919L131.367 64.2827Z",
    fill: "url(#paint129_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.326 19.4402C162.896 18.2857 160.527 17.0704 158.097 15.7944V19.5617L165.326 19.4402Z",
    fill: "url(#paint130_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.592 20.9592L149.653 26.6101L152.387 28.1899H156.882L156.822 20.8984L149.592 20.9592Z",
    fill: "url(#paint131_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.824 38.3372L132.534 38.4102L132.607 45.7016L139.897 45.6287L139.824 38.3372Z",
    fill: "url(#paint132_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.245 46.9653L128.086 47.0261V54.3175L131.367 54.2568L131.245 46.9653Z",
    fill: "url(#paint133_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.187 12.3855L140.836 12.4612L140.912 19.813L148.262 19.7373L148.187 12.3855Z",
    fill: "url(#paint134_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.124 30.985L129.605 29.7698H128.147V37.0612H131.185L131.124 30.985Z",
    fill: "url(#paint135_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.629 11.2374L139.507 4.31053L138.778 3.76367L132.035 3.82443L132.157 11.2982L139.629 11.2374Z",
    fill: "url(#paint136_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.003 12.7563H129.302L131.003 14.1539V12.7563Z",
    fill: "url(#paint137_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.772 214.851L215.688 210.416H212.772V214.851Z",
    fill: "url(#paint138_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.085 224.999H205.421C206.819 223.054 208.277 221.11 209.674 218.922H204.024L204.085 224.999Z",
    fill: "url(#paint139_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.519 227.854V233.93H198.557L201.351 230.467V228.037L195.519 227.854Z",
    fill: "url(#paint140_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.954 236.543V242.619H191.206L192.846 240.797V236.725L186.954 236.543Z",
    fill: "url(#paint141_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.298 245.206L178.467 245.266L178.527 251.099L184.359 251.039L184.298 245.206Z",
    fill: "url(#paint142_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.822 253.921L169.991 253.981L170.051 259.814L175.882 259.754L175.822 253.921Z",
    fill: "url(#paint143_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.225 262.576L161.394 262.636L161.454 268.469L167.285 268.409L167.225 262.576Z",
    fill: "url(#paint144_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.934 271.36V277.436H154.331C155.789 276.342 157.247 275.127 158.705 273.912V271.542L152.934 271.36Z",
    fill: "url(#paint145_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.368 280.11V284.667C146.19 283.391 148.134 281.993 150.443 280.413V280.11H144.368Z",
    fill: "url(#paint146_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.863 290.378L138.475 288.738H135.863V290.378Z",
    fill: "url(#paint147_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.418 181.736H231.605C232.516 179.731 233.488 177.786 234.338 175.66H229.357L229.418 181.736Z",
    fill: "url(#paint148_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.742 184.435L220.789 184.496L220.85 190.45L226.804 190.389L226.742 184.435Z",
    fill: "url(#paint149_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.266 193.15L212.313 193.211L212.375 199.166L218.328 199.104L218.266 193.15Z",
    fill: "url(#paint150_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.735 201.848H207.244C206.15 203.61 204.996 205.372 203.842 207.074V207.864H209.917L209.735 201.848Z",
    fill: "url(#paint151_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.29 216.492V210.902L197.22 216.552L201.29 216.492Z",
    fill: "url(#paint152_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.355 225.424H192.785V222.507L190.355 225.424Z",
    fill: "url(#paint153_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.883 233.87H184.281V232.351C183.795 232.897 183.309 233.384 182.883 233.87Z",
    fill: "url(#paint154_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.715 242.559V241.526L174.682 242.62L175.715 242.559Z",
    fill: "url(#paint155_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.569 251.308H167.21V249.729L165.569 251.308Z",
    fill: "url(#paint156_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.485 259.998H158.705V257.385L155.485 259.998Z",
    fill: "url(#paint157_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.139 264.251C148.134 265.77 146.312 267.167 144.489 268.443H150.564L150.139 264.251Z",
    fill: "url(#paint158_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.573 271.421H140.297L135.68 274.52V277.436H141.755L141.573 271.421Z",
    fill: "url(#paint159_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.904 280.17V286.125L133.129 286.064L133.068 280.11L127.904 280.17Z",
    fill: "url(#paint160_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.185 143.516C246.185 142.727 246.671 141.937 246.853 141.147H246.185V143.516Z",
    fill: "url(#paint161_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.619 149.836V155.912H242.175L243.633 151.537V149.836H237.619Z",
    fill: "url(#paint162_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.222 158.465L229.147 158.527L229.21 164.603L235.285 164.541L235.222 158.465Z",
    fill: "url(#paint163_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.735 173.229H226.745V167.153H225.408C224.497 169.219 223.586 171.285 222.735 173.229Z",
    fill: "url(#paint164_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.033 193.342V197.959C196.066 196.44 197.038 194.861 198.071 193.281L195.033 193.342Z",
    fill: "url(#paint165_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.421 201.97H186.346V208.046H187.743L192.421 201.97Z",
    fill: "url(#paint166_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.098 213.271V210.902H178.023V216.978H181L184.098 213.271Z",
    fill: "url(#paint167_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.528 219.352L169.453 219.415L169.516 225.49L175.59 225.428L175.528 219.352Z",
    fill: "url(#paint168_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.088 231.925V228.037H161.013V234.113H164.78L167.088 231.925Z",
    fill: "url(#paint169_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.522 239.885V236.726H152.447V242.802H155.06L158.522 239.885Z",
    fill: "url(#paint170_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.017 245.475H143.942V251.551C145.826 250.215 147.77 248.696 150.017 247.055V245.475Z",
    fill: "url(#paint171_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.438 254.225V257.628L140.541 254.164L135.438 254.225Z",
    fill: "url(#paint172_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.002 130.027H249.708C250.194 128.022 250.619 125.956 251.045 123.951H245.942L246.002 130.027Z",
    fill: "url(#paint173_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52 132.496L237.385 132.559L237.448 138.695L243.584 138.632L243.52 132.496Z",
    fill: "url(#paint174_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.128 147.345V141.268H234.399L232.577 147.345H235.128Z",
    fill: "url(#paint175_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.324 158.585H211.861V164.662H212.772C213.683 162.778 214.534 160.712 215.324 158.585Z",
    fill: "url(#paint176_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.435 167.297L203.3 167.36L203.363 173.497L209.499 173.434L209.435 167.297Z",
    fill: "url(#paint177_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.96 176.012L194.824 176.075L194.887 182.212L201.023 182.149L200.96 176.012Z",
    fill: "url(#paint178_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.423 184.667L186.288 184.73L186.351 190.867L192.486 190.803L192.423 184.667Z",
    fill: "url(#paint179_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.947 193.382L177.812 193.445L177.875 199.582L184.01 199.519L183.947 193.382Z",
    fill: "url(#paint180_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35 202.037L169.214 202.101L169.278 208.237L175.413 208.174L175.35 202.037Z",
    fill: "url(#paint181_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.874 210.753L160.738 210.816L160.801 216.953L166.937 216.889L166.874 210.753Z",
    fill: "url(#paint182_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.338 219.529L152.203 219.592L152.266 225.729L158.401 225.666L158.338 219.529Z",
    fill: "url(#paint183_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.862 228.183L143.727 228.247L143.79 234.383L149.925 234.32L149.862 228.183Z",
    fill: "url(#paint184_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.265 236.899L135.129 236.963L135.193 243.099L141.328 243.036L141.265 236.899Z",
    fill: "url(#paint185_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.825 245.597H127.965V251.794L132.886 251.734L132.825 245.597Z",
    fill: "url(#paint186_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.264 103.899L255.297 97.8232H254.447L254.264 103.899Z",
    fill: "url(#paint187_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.001 106.525L245.744 106.59L245.808 112.848L252.065 112.784L252.001 106.525Z",
    fill: "url(#paint188_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.834 121.521H243.512V115.444H239.988C239.624 117.389 239.259 119.455 238.834 121.521Z",
    fill: "url(#paint189_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.16 132.64H220.123V138.716H221.52C222.128 136.893 222.674 134.767 223.16 132.64Z",
    fill: "url(#paint190_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.936 147.588H211.861V144.003C212.286 143.152 212.772 142.241 213.137 141.329H218.057L217.936 147.588Z",
    fill: "url(#paint191_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.431 156.277H203.356V154.514C204.23 153.772 205.062 152.981 205.847 152.145C206.515 151.416 207.183 150.747 207.791 149.957H209.552L209.431 156.277Z",
    fill: "url(#paint192_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.926 164.966H194.547V160.408L197.463 158.768H200.622L200.926 164.966Z",
    fill: "url(#paint193_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.306 167.413L186.049 167.477L186.114 173.735L192.371 173.671L192.306 167.413Z",
    fill: "url(#paint194_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.83 176.128L177.573 176.192L177.638 182.451L183.895 182.386L183.83 176.128Z",
    fill: "url(#paint195_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.294 184.783L169.037 184.847L169.101 191.105L175.358 191.041L175.294 184.783Z",
    fill: "url(#paint196_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.757 193.499L160.5 193.563L160.564 199.821L166.821 199.757L166.757 193.499Z",
    fill: "url(#paint197_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.775 217.16L143.517 217.221L143.457 211.935H149.775V217.16Z",
    fill: "url(#paint198_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.151 219.698L134.894 219.761L134.956 226.019L141.213 225.957L141.151 219.698Z",
    fill: "url(#paint199_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.704 228.28L127.965 228.34V234.599L132.765 234.538L132.704 228.28Z",
    fill: "url(#paint200_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.082 87.0079H255.966C255.966 84.9419 255.966 82.8153 255.966 80.9316H253.718L254.082 87.0079Z",
    fill: "url(#paint201_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.883 89.2104L245.505 89.2761L245.571 95.6558L251.949 95.5901L251.883 89.2104Z",
    fill: "url(#paint202_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 104.325H243.147V97.8232H241.811C241.811 100.132 241.628 102.259 241.385 104.325Z",
    fill: "url(#paint203_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.259 115.444H220.184V121.824H225.53C225.651 119.637 226.016 117.571 226.259 115.444Z",
    fill: "url(#paint204_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.815 130.392H216.114C216.421 128.278 216.604 126.147 216.66 124.012H217.754L217.815 130.392Z",
    fill: "url(#paint205_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.734 165.209H181.364L183.734 164.601V165.209Z",
    fill: "url(#paint206_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.177 167.528L168.798 167.594L168.864 173.974L175.242 173.908L175.177 167.528Z",
    fill: "url(#paint207_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.643 217.403L127.965 217.464V211.084L130.76 211.023L130.699 211.874H132.582L132.643 217.403Z",
    fill: "url(#paint208_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.451 63.3105H253.778V69.7513H256.451C256.512 67.4424 256.512 65.498 256.451 63.3105Z",
    fill: "url(#paint209_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.698 72.0352L245.258 72.0996L245.323 78.5404L251.762 78.476L251.698 72.0352Z",
    fill: "url(#paint210_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.661 87.1293H243.147V80.6885H242.722C242.783 82.8759 242.722 85.0026 242.661 87.1293Z",
    fill: "url(#paint211_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.096 98.1034L219.657 98.1697L219.724 104.61L226.163 104.544L226.096 98.1034Z",
    fill: "url(#paint212_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.693 113.257H215.81C215.355 111.056 214.705 108.901 213.866 106.816H217.632L217.693 113.257Z",
    fill: "url(#paint213_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.821 193.767L130.76 200.207L127.965 200.268V193.827L130.821 193.767Z",
    fill: "url(#paint214_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.601 46.0542H253.535V52.6165H255.965C255.905 50.4291 255.783 48.2416 255.601 46.0542Z",
    fill: "url(#paint215_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.528 54.7024L244.967 54.77L245.035 61.332L251.595 61.2644L251.528 54.7024Z",
    fill: "url(#paint216_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.722 69.9944H243.147V63.4321H242.54C242.601 65.6196 242.661 67.807 242.722 69.9944Z",
    fill: "url(#paint217_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.04 80.8484L219.48 80.916L219.547 87.478L226.108 87.4104L226.04 80.8484Z",
    fill: "url(#paint218_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.504 89.5037L210.943 89.5713L211.011 96.1332L217.571 96.0657L217.504 89.5037Z",
    fill: "url(#paint219_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.257 122.128H185.435V115.688H185.738C186.702 117.7 187.22 119.897 187.257 122.128Z",
    fill: "url(#paint220_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.479 124.304L176.918 124.372L176.986 130.934L183.546 130.866L183.479 124.304Z",
    fill: "url(#paint221_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.986 139.567H174.196H174.135H174.074L168.425 139.628L168.364 133.065L174.925 133.005L174.986 139.385V139.567Z",
    fill: "url(#paint222_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.881 176.51V183.073H128.026V176.51H130.881Z",
    fill: "url(#paint223_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.47 41.2539C249.769 41.2539 247.521 41.2539 244.848 40.8286V44.1705H251.531L251.47 41.2539Z",
    fill: "url(#paint224_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.689 52.434V52.7986H243.147V46.1147H236.525V52.191C239.745 52.434 241.689 52.434 241.689 52.434Z",
    fill: "url(#paint225_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.894 64.2218C224.558 64.2218 222.31 64.2218 219.212 63.918V69.9942H225.894V64.2218Z",
    fill: "url(#paint226_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.376 72.2564L210.694 72.3232L210.761 79.0071L217.443 78.9402L217.376 72.2564Z",
    fill: "url(#paint227_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.85 80.9649L202.168 81.0337L202.237 87.7172L208.919 87.6483L208.85 80.9649Z",
    fill: "url(#paint228_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.369 112.467V113.682L176.687 113.743L176.626 108.821L183.369 112.467Z",
    fill: "url(#paint229_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.825 115.705L168.143 115.773L168.212 122.457L174.894 122.388L174.825 115.705Z",
    fill: "url(#paint230_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.289 124.421L159.606 124.49L159.675 131.173L166.357 131.104L166.289 124.421Z",
    fill: "url(#paint231_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.753 133.136L151.071 133.205L151.14 139.888L157.822 139.819L157.753 133.136Z",
    fill: "url(#paint232_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.003 159.254L130.942 165.877L128.026 165.938V159.254H131.003Z",
    fill: "url(#paint233_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.338 44.3528V39.7349C232.212 39.7349 229.964 39.1273 227.595 38.7627V44.4136L234.338 44.3528Z",
    fill: "url(#paint234_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.847 50.4897L225.651 51.4011V46.2971H218.847V50.4897Z",
    fill: "url(#paint235_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.733 63.6498L201.99 63.7192L202.059 70.4635L208.802 70.394L208.733 63.6498Z",
    fill: "url(#paint236_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.136 72.3656L193.393 72.4351L193.463 79.1793L200.205 79.1098L200.136 72.3656Z",
    fill: "url(#paint237_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.753 85.671C189.531 84.838 187.258 84.148 184.949 83.6051V81.3569H191.692L191.753 85.671Z",
    fill: "url(#paint238_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.177 113.925L159.434 113.986L159.373 107.667H166.116L166.177 113.925Z",
    fill: "url(#paint239_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.574 115.822L150.832 115.891L150.901 122.635L157.644 122.566L157.574 115.822Z",
    fill: "url(#paint240_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.038 124.598L142.295 124.667L142.365 131.411L149.108 131.342L149.038 124.598Z",
    fill: "url(#paint241_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.563 133.252L133.82 133.322L133.889 140.066L140.632 139.997L140.563 133.252Z",
    fill: "url(#paint242_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.063 141.937V148.742H128.026V141.997L131.063 141.937Z",
    fill: "url(#paint243_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.092 37.6803L210.227 37.751L210.298 44.6167L217.162 44.546L217.092 37.6803Z",
    fill: "url(#paint244_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.776 47.1476C204.085 47.6945 206.393 48.2413 208.641 48.6667V46.4185H201.716L201.776 47.1476Z",
    fill: "url(#paint245_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.271 62.0344H200.136V61.366L193.271 59.9077V62.0344Z",
    fill: "url(#paint246_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.543 63.8268L184.679 63.8975L184.749 70.7632L191.614 70.6925L191.543 63.8268Z",
    fill: "url(#paint247_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.006 72.5421L176.142 72.6128L176.213 79.4785L183.077 79.4078L183.006 72.5421Z",
    fill: "url(#paint248_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.046 114.168L142.181 114.229L142.12 107.606H148.985L149.046 114.168Z",
    fill: "url(#paint249_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.445 115.937L133.581 116.008L133.651 122.874L140.516 122.803L140.445 115.937Z",
    fill: "url(#paint250_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.914 124.68L128.026 124.741V131.607L131.975 131.546L131.914 124.68Z",
    fill: "url(#paint251_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52 36.0892V34.9347L201.533 33.1118V36.1499L208.52 36.0892Z",
    fill: "url(#paint252_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.962 37.8574L192.976 37.9272L193.045 44.9149L200.032 44.845L199.962 37.8574Z",
    fill: "url(#paint253_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.958 55.29V62.2777H182.944V57.1737L176.93 55.29H175.958Z",
    fill: "url(#paint254_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.414 63.9427L167.428 64.0146L167.5 71.0019L174.486 70.93L174.414 63.9427Z",
    fill: "url(#paint255_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.877 72.658L158.892 72.73L158.964 79.7173L165.949 79.6453L165.877 72.658Z",
    fill: "url(#paint256_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.368 81.2959V81.3567H154.513L157.368 81.2959Z",
    fill: "url(#paint257_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.853 114.351L128.026 114.411L128.087 107.424H131.246H131.792V107.606L131.853 114.351Z",
    fill: "url(#paint258_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.341 36.3929L191.388 36.3321L191.327 30.0128L189.201 29.2837L184.22 29.3445L184.341 36.3929Z",
    fill: "url(#paint259_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.715 39.1879L182.823 41.7399V37.9727H175.715V39.1879Z",
    fill: "url(#paint260_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.271 53.7708H172.495L167.271 51.7656V53.7708Z",
    fill: "url(#paint261_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.699 55.4042L158.653 55.4768L158.725 62.5248L165.772 62.4523L165.699 55.4042Z",
    fill: "url(#paint262_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.224 64.0588L150.177 64.1313L150.25 71.1794L157.296 71.1068L157.224 64.0588Z",
    fill: "url(#paint263_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.687 72.7741L141.641 72.8467L141.713 79.8947L148.76 79.8221L148.687 72.7741Z",
    fill: "url(#paint264_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.367 90.1675L131.306 97.2159H128.086V90.1675H131.367Z",
    fill: "url(#paint265_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.701 27.8254V26.9747L175.532 24.1189V27.8861L182.701 27.8254Z",
    fill: "url(#paint266_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.028 35.5422L169.397 36.5752L174.196 36.5144L174.135 29.4053L166.967 29.466L167.028 35.5422Z",
    fill: "url(#paint267_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.957 46.844L150.017 54.0139L157.186 53.9531L157.125 47.2085L156.275 46.7832L149.957 46.844Z",
    fill: "url(#paint268_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.57 55.5199L141.402 55.5938L141.476 62.7633L148.644 62.6895L148.57 55.5199Z",
    fill: "url(#paint269_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.094 64.1745L132.926 64.2483L133 71.4178L140.168 71.344L140.094 64.1745Z",
    fill: "url(#paint270_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.549 72.8501L128.086 72.9109V80.0808L131.61 80.02L131.549 72.8501Z",
    fill: "url(#paint271_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.526 20.8343L158.236 20.9094L158.311 28.2005L165.601 28.1254L165.526 20.8343Z",
    fill: "url(#paint272_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.003 30.9851V29.5269H154.816L157.003 30.9851Z",
    fill: "url(#paint273_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.208 38.2764V45.5678H148.438V42.6512C146.008 41.3145 143.638 39.8562 141.269 38.2764H141.208Z",
    fill: "url(#paint274_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.978 46.9203L132.688 46.9954L132.763 54.2864L140.053 54.2113L139.978 46.9203Z",
    fill: "url(#paint275_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.428 55.5938L128.086 55.6545V62.8852H131.488L131.428 55.5938Z",
    fill: "url(#paint276_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.531 19.6835L156.943 19.6227L156.882 15.1263L151.901 12.2705L149.471 12.3313L149.531 19.6835Z",
    fill: "url(#paint277_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.966 21.1418L141.999 21.8709C144.105 23.2482 146.13 24.5849 148.074 25.8812V20.9595H140.966V21.1418Z",
    fill: "url(#paint278_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.521 37.0611H139.386C137.077 35.4813 134.769 33.8407 132.46 32.0786L132.521 37.0611Z",
    fill: "url(#paint279_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.306 38.3374H128.147V45.7504L131.367 45.6896L131.306 38.3374Z",
    fill: "url(#paint280_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.256 11.1158V10.0829C145.947 8.50305 143.213 6.68019 140.723 5.16113V11.2373L148.256 11.1158Z",
    fill: "url(#paint281_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.218 14.8223C134.466 16.5844 136.713 18.225 139.022 19.8048H139.872V12.3918H132.218V14.8223Z",
    fill: "url(#paint282_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.724 182.586L160.345 182.647L160.284 179.184V176.328H160.345L166.663 176.267L166.724 182.586Z",
    fill: "url(#paint283_linear_65_324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.525 199.874H511.068V195.718H584.406V199.874H549.95V289.569H545.525V199.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.043 236.744C592.098 231.203 595.406 226.957 599.964 224.007C604.612 220.968 610.332 219.449 617.125 219.449V223.873H615.919C607.874 223.873 601.573 226.421 597.014 231.516C592.456 236.61 590.177 243.627 590.177 252.565V289.569H585.752V219.985H590.043V236.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.194 219.985V289.569H680.903V272.676C678.758 278.128 675.317 282.374 670.58 285.413C665.842 288.452 660.211 289.971 653.686 289.971C644.659 289.971 637.598 287.469 632.503 282.463C627.408 277.458 624.861 270.263 624.861 260.878V219.985H629.285V260.609C629.285 268.832 631.386 275.134 635.587 279.514C639.877 283.804 645.955 285.949 653.82 285.949C662.133 285.949 668.703 283.402 673.529 278.307C678.356 273.123 680.769 266.196 680.769 257.526V219.985H685.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.652 289.971C714.021 289.971 708.703 289.122 703.698 287.424C698.782 285.726 694.938 283.491 692.167 280.72L694.313 277.234C697.173 279.737 700.837 281.838 705.307 283.536C709.865 285.234 714.692 286.083 719.786 286.083C727.295 286.083 732.836 284.832 736.412 282.329C739.987 279.737 741.774 276.162 741.774 271.603C741.774 268.386 740.791 265.838 738.825 263.961C736.948 262.084 734.579 260.699 731.719 259.805C728.859 258.911 725.015 258.017 720.189 257.123C714.558 256.051 710.044 254.978 706.647 253.906C703.34 252.744 700.525 250.911 698.201 248.409C695.877 245.906 694.715 242.42 694.715 237.951C694.715 232.677 696.86 228.298 701.15 224.812C705.53 221.237 711.876 219.449 720.189 219.449C724.479 219.449 728.769 220.119 733.06 221.46C737.35 222.711 740.836 224.41 743.517 226.555L741.238 230.041C738.467 227.896 735.205 226.287 731.451 225.214C727.786 224.052 723.987 223.471 720.055 223.471C713.172 223.471 707.988 224.812 704.502 227.493C701.016 230.085 699.273 233.527 699.273 237.817C699.273 241.213 700.257 243.895 702.223 245.861C704.189 247.828 706.603 249.303 709.463 250.286C712.412 251.18 716.39 252.118 721.395 253.101C726.758 254.084 731.093 255.157 734.4 256.319C737.708 257.392 740.478 259.135 742.713 261.548C745.037 263.961 746.199 267.313 746.199 271.603C746.199 277.234 743.92 281.704 739.361 285.011C734.803 288.318 728.233 289.971 719.652 289.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.652 285.145C785.043 286.664 782.988 287.871 780.485 288.765C777.982 289.569 775.39 289.971 772.709 289.971C767.078 289.971 762.698 288.407 759.569 285.279C756.531 282.061 755.011 277.681 755.011 272.14V223.873H741.872V219.985H755.011V204.701H759.435V219.985H782.362V223.873H759.435V271.469C759.435 276.207 760.597 279.826 762.921 282.329C765.245 284.832 768.642 286.083 773.111 286.083C777.58 286.083 781.334 284.698 784.373 281.927L786.652 285.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.467 195.718V289.569H867.713L801.079 204.031V289.569H796.52V195.718H800.274L866.909 281.257V195.718H871.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.885 255.381H887.882C887.971 261.28 889.356 266.553 892.038 271.201C894.719 275.849 898.384 279.469 903.032 282.061C907.769 284.653 913.043 285.949 918.852 285.949C923.59 285.949 927.969 285.1 931.992 283.402C936.014 281.614 939.321 279.022 941.913 275.626L944.729 278.575C941.6 282.24 937.801 285.055 933.332 287.022C928.863 288.988 924.037 289.971 918.852 289.971C912.059 289.971 905.981 288.497 900.619 285.547C895.345 282.508 891.189 278.307 888.15 272.944C885.111 267.581 883.591 261.503 883.591 254.71C883.591 247.917 884.977 241.839 887.748 236.476C890.608 231.113 894.541 226.957 899.546 224.007C904.551 220.968 910.138 219.449 916.305 219.449C922.383 219.449 927.88 220.924 932.796 223.873C937.801 226.823 941.734 230.935 944.594 236.208C947.455 241.482 948.885 247.47 948.885 254.174V255.381ZM916.305 223.471C911.121 223.471 906.428 224.678 902.227 227.091C898.026 229.504 894.675 232.901 892.172 237.281C889.669 241.571 888.284 246.398 888.016 251.761H944.729C944.371 246.398 942.896 241.571 940.304 237.281C937.801 232.901 934.45 229.504 930.249 227.091C926.137 224.678 921.489 223.471 916.305 223.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.496 285.145C989.887 286.664 987.831 287.871 985.329 288.765C982.826 289.569 980.234 289.971 977.552 289.971C971.921 289.971 967.542 288.407 964.413 285.279C961.374 282.061 959.855 277.681 959.855 272.14V223.873H946.716V219.985H959.855V204.701H964.279V219.985H987.206V223.873H964.279V271.469C964.279 276.207 965.441 279.826 967.765 282.329C970.089 284.832 973.485 286.083 977.955 286.083C982.424 286.083 986.178 284.698 989.217 281.927L991.496 285.145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_324",
    x1: 122.948,
    y1: 185.195,
    x2: 253.56,
    y2: 186.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_65_324",
    x1: 122.839,
    y1: 196.011,
    x2: 253.452,
    y2: 197.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_65_324",
    x1: 123.908,
    y1: 204.319,
    x2: 254.519,
    y2: 205.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_65_324",
    x1: 123.802,
    y1: 213.007,
    x2: 254.413,
    y2: 213.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_65_324",
    x1: 123.818,
    y1: 221.816,
    x2: 254.429,
    y2: 222.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_65_324",
    x1: 122.49,
    y1: 230.949,
    x2: 253.103,
    y2: 232.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_65_324",
    x1: 122.403,
    y1: 239.699,
    x2: 253.015,
    y2: 241.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_65_324",
    x1: 122.315,
    y1: 248.448,
    x2: 252.928,
    y2: 249.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_65_324",
    x1: 122.228,
    y1: 257.198,
    x2: 252.841,
    y2: 258.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_65_324",
    x1: 123.533,
    y1: 265.499,
    x2: 254.144,
    y2: 266.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_65_324",
    x1: 123.548,
    y1: 274.187,
    x2: 254.159,
    y2: 274.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_65_324",
    x1: 123.443,
    y1: 282.997,
    x2: 254.054,
    y2: 283.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_65_324",
    x1: 121.878,
    y1: 292.197,
    x2: 252.491,
    y2: 293.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_65_324",
    x1: 123.187,
    y1: 161.315,
    x2: 253.799,
    y2: 162.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_65_324",
    x1: 124.027,
    y1: 169.628,
    x2: 254.638,
    y2: 170.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_65_324",
    x1: 123.095,
    y1: 178.811,
    x2: 253.728,
    y2: 180.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_65_324",
    x1: 122.925,
    y1: 187.504,
    x2: 253.537,
    y2: 188.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_65_324",
    x1: 122.812,
    y1: 198.623,
    x2: 253.427,
    y2: 199.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_65_324",
    x1: 122.6,
    y1: 220.012,
    x2: 253.212,
    y2: 221.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_65_324",
    x1: 122.51,
    y1: 228.944,
    x2: 253.124,
    y2: 230.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_65_324",
    x1: 122.425,
    y1: 237.45,
    x2: 253.037,
    y2: 238.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_65_324",
    x1: 122.027,
    y1: 277.31,
    x2: 252.639,
    y2: 278.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_65_324",
    x1: 123.446,
    y1: 135.37,
    x2: 254.058,
    y2: 136.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_65_324",
    x1: 124.222,
    y1: 143.564,
    x2: 254.833,
    y2: 144.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_65_324",
    x1: 123.272,
    y1: 152.809,
    x2: 253.884,
    y2: 154.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_65_324",
    x1: 123.009,
    y1: 179.058,
    x2: 253.622,
    y2: 180.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_65_324",
    x1: 122.922,
    y1: 187.808,
    x2: 253.534,
    y2: 189.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_65_324",
    x1: 123.953,
    y1: 196.056,
    x2: 254.564,
    y2: 196.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_65_324",
    x1: 123.847,
    y1: 204.805,
    x2: 254.458,
    y2: 205.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_65_324",
    x1: 123.802,
    y1: 213.554,
    x2: 254.413,
    y2: 214.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_65_324",
    x1: 123.758,
    y1: 222.242,
    x2: 254.369,
    y2: 222.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_65_324",
    x1: 123.714,
    y1: 231.051,
    x2: 254.324,
    y2: 231.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_65_324",
    x1: 123.668,
    y1: 239.739,
    x2: 254.279,
    y2: 240.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_65_324",
    x1: 123.624,
    y1: 248.549,
    x2: 254.234,
    y2: 249.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_65_324",
    x1: 122.222,
    y1: 257.745,
    x2: 252.835,
    y2: 259.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_65_324",
    x1: 123.619,
    y1: 118.113,
    x2: 254.231,
    y2: 119.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_65_324",
    x1: 123.531,
    y1: 126.863,
    x2: 254.144,
    y2: 128.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_65_324",
    x1: 123.375,
    y1: 142.54,
    x2: 253.986,
    y2: 143.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_65_324",
    x1: 123.268,
    y1: 153.113,
    x2: 253.881,
    y2: 154.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_65_324",
    x1: 124.133,
    y1: 161.365,
    x2: 254.744,
    y2: 162.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_65_324",
    x1: 124.028,
    y1: 170.114,
    x2: 254.639,
    y2: 170.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_65_324",
    x1: 124.043,
    y1: 178.802,
    x2: 254.654,
    y2: 179.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_65_324",
    x1: 123.938,
    y1: 187.612,
    x2: 254.549,
    y2: 188.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_65_324",
    x1: 123.954,
    y1: 196.299,
    x2: 254.564,
    y2: 196.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_65_324",
    x1: 123.848,
    y1: 205.048,
    x2: 254.458,
    y2: 205.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_65_324",
    x1: 122.651,
    y1: 214.847,
    x2: 253.264,
    y2: 216.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_65_324",
    x1: 123.699,
    y1: 222.594,
    x2: 254.316,
    y2: 223.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_65_324",
    x1: 123.714,
    y1: 231.355,
    x2: 254.324,
    y2: 232.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_65_324",
    x1: 122.395,
    y1: 240.489,
    x2: 253.007,
    y2: 241.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_65_324",
    x1: 123.877,
    y1: 92.1683,
    x2: 254.491,
    y2: 93.4742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_65_324",
    x1: 124.387,
    y1: 100.428,
    x2: 254.998,
    y2: 101.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_65_324",
    x1: 123.703,
    y1: 109.607,
    x2: 254.316,
    y2: 110.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_65_324",
    x1: 123.528,
    y1: 127.167,
    x2: 254.141,
    y2: 128.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_65_324",
    x1: 123.441,
    y1: 135.856,
    x2: 254.054,
    y2: 137.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_65_324",
    x1: 123.165,
    y1: 163.503,
    x2: 253.777,
    y2: 164.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_65_324",
    x1: 124.028,
    y1: 170.418,
    x2: 254.639,
    y2: 171.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_65_324",
    x1: 124.044,
    y1: 179.106,
    x2: 254.655,
    y2: 179.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_65_324",
    x1: 123.938,
    y1: 187.854,
    x2: 254.549,
    y2: 188.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_65_324",
    x1: 122.65,
    y1: 215.029,
    x2: 253.262,
    y2: 216.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_65_324",
    x1: 122.567,
    y1: 223.293,
    x2: 253.179,
    y2: 224.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_65_324",
    x1: 124.05,
    y1: 74.9725,
    x2: 254.662,
    y2: 76.2784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_65_324",
    x1: 124.477,
    y1: 83.1741,
    x2: 255.088,
    y2: 83.8579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_65_324",
    x1: 123.875,
    y1: 92.4113,
    x2: 254.488,
    y2: 93.7171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_65_324",
    x1: 124.403,
    y1: 109.42,
    x2: 255.014,
    y2: 110.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_65_324",
    x1: 123.614,
    y1: 118.6,
    x2: 254.226,
    y2: 119.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_65_324",
    x1: 123.089,
    y1: 171.098,
    x2: 253.701,
    y2: 172.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_65_324",
    x1: 122.739,
    y1: 206.097,
    x2: 253.351,
    y2: 207.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_65_324",
    x1: 124.223,
    y1: 57.777,
    x2: 254.834,
    y2: 59.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_65_324",
    x1: 124.616,
    y1: 66.0203,
    x2: 255.233,
    y2: 66.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_65_324",
    x1: 124.493,
    y1: 92.2263,
    x2: 255.104,
    y2: 92.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_65_324",
    x1: 123.785,
    y1: 101.404,
    x2: 254.398,
    y2: 102.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_65_324",
    x1: 123.523,
    y1: 127.714,
    x2: 254.135,
    y2: 129.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_65_324",
    x1: 123.439,
    y1: 136.038,
    x2: 254.052,
    y2: 137.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_65_324",
    x1: 122.912,
    y1: 188.841,
    x2: 253.524,
    y2: 190.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_65_324",
    x1: 124.718,
    y1: 48.7864,
    x2: 255.329,
    y2: 49.4702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_65_324",
    x1: 124.22,
    y1: 57.9591,
    x2: 254.832,
    y2: 59.2649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_65_324",
    x1: 124.508,
    y1: 75.0128,
    x2: 255.125,
    y2: 75.7355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_65_324",
    x1: 124.478,
    y1: 83.721,
    x2: 255.089,
    y2: 84.4047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_65_324",
    x1: 123.871,
    y1: 92.8973,
    x2: 254.483,
    y2: 94.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_65_324",
    x1: 124.299,
    y1: 118.776,
    x2: 254.909,
    y2: 119.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_65_324",
    x1: 124.283,
    y1: 127.508,
    x2: 254.9,
    y2: 128.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_65_324",
    x1: 124.208,
    y1: 136.213,
    x2: 254.819,
    y2: 136.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_65_324",
    x1: 123.083,
    y1: 171.645,
    x2: 253.696,
    y2: 172.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_65_324",
    x1: 124.379,
    y1: 42.0394,
    x2: 254.992,
    y2: 43.3453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_65_324",
    x1: 124.309,
    y1: 49.0879,
    x2: 254.921,
    y2: 50.3938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_65_324",
    x1: 124.129,
    y1: 67.0127,
    x2: 254.742,
    y2: 68.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_65_324",
    x1: 124.523,
    y1: 75.2759,
    x2: 255.134,
    y2: 75.9596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_65_324",
    x1: 123.955,
    y1: 84.4514,
    x2: 254.568,
    y2: 85.7573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_65_324",
    x1: 123.689,
    y1: 111.065,
    x2: 254.302,
    y2: 112.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_65_324",
    x1: 124.299,
    y1: 118.959,
    x2: 254.909,
    y2: 119.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_65_324",
    x1: 124.315,
    y1: 127.707,
    x2: 254.926,
    y2: 128.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_65_324",
    x1: 124.209,
    y1: 136.456,
    x2: 254.819,
    y2: 137.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_65_324",
    x1: 123.255,
    y1: 154.449,
    x2: 253.868,
    y2: 155.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_65_324",
    x1: 124.389,
    y1: 41.0672,
    x2: 255.001,
    y2: 42.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_65_324",
    x1: 124.316,
    y1: 48.298,
    x2: 254.929,
    y2: 49.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_65_324",
    x1: 124.181,
    y1: 61.8481,
    x2: 254.794,
    y2: 63.1539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_65_324",
    x1: 124.629,
    y1: 66.7697,
    x2: 255.24,
    y2: 67.4535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_65_324",
    x1: 124.524,
    y1: 75.5187,
    x2: 255.134,
    y2: 76.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_65_324",
    x1: 123.977,
    y1: 82.2033,
    x2: 254.59,
    y2: 83.5092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_65_324",
    x1: 123.688,
    y1: 111.187,
    x2: 254.3,
    y2: 112.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_65_324",
    x1: 124.299,
    y1: 119.262,
    x2: 254.91,
    y2: 119.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_65_324",
    x1: 124.255,
    y1: 127.95,
    x2: 254.865,
    y2: 128.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_65_324",
    x1: 123.428,
    y1: 137.193,
    x2: 254.041,
    y2: 138.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_65_324",
    x1: 124.442,
    y1: 35.7202,
    x2: 255.055,
    y2: 37.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_65_324",
    x1: 124.703,
    y1: 40.8278,
    x2: 255.314,
    y2: 41.5116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_65_324",
    x1: 124.199,
    y1: 60.0251,
    x2: 254.812,
    y2: 61.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_65_324",
    x1: 124.63,
    y1: 67.1343,
    x2: 255.24,
    y2: 67.8181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_65_324",
    x1: 124.524,
    y1: 75.8227,
    x2: 255.134,
    y2: 76.5065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_65_324",
    x1: 123.983,
    y1: 81.5955,
    x2: 254.596,
    y2: 82.9013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_65_324",
    x1: 123.686,
    y1: 111.369,
    x2: 254.298,
    y2: 112.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_65_324",
    x1: 123.6,
    y1: 119.997,
    x2: 254.212,
    y2: 121.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_65_324",
    x1: 124.464,
    y1: 33.4721,
    x2: 255.077,
    y2: 34.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_65_324",
    x1: 124.387,
    y1: 41.3105,
    x2: 254.999,
    y2: 42.6164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_65_324",
    x1: 124.604,
    y1: 58.6082,
    x2: 255.221,
    y2: 59.3309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_65_324",
    x1: 124.631,
    y1: 67.3774,
    x2: 255.241,
    y2: 68.0611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_65_324",
    x1: 124.524,
    y1: 76.0657,
    x2: 255.135,
    y2: 76.7494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_65_324",
    x1: 123.772,
    y1: 102.741,
    x2: 254.385,
    y2: 104.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_65_324",
    x1: 124.81,
    y1: 32.6256,
    x2: 255.421,
    y2: 33.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_65_324",
    x1: 124.414,
    y1: 38.5153,
    x2: 255.026,
    y2: 39.8211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_65_324",
    x1: 124.287,
    y1: 51.2146,
    x2: 254.9,
    y2: 52.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_65_324",
    x1: 124.614,
    y1: 58.8721,
    x2: 255.225,
    y2: 59.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_65_324",
    x1: 124.63,
    y1: 67.6203,
    x2: 255.241,
    y2: 68.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_65_324",
    x1: 124.525,
    y1: 76.3087,
    x2: 255.136,
    y2: 76.9925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_65_324",
    x1: 123.944,
    y1: 85.5451,
    x2: 254.557,
    y2: 86.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_65_324",
    x1: 124.553,
    y1: 24.6616,
    x2: 255.165,
    y2: 25.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_65_324",
    x1: 124.475,
    y1: 32.4389,
    x2: 255.088,
    y2: 33.7448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_65_324",
    x1: 124.352,
    y1: 44.7739,
    x2: 254.964,
    y2: 46.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_65_324",
    x1: 124.721,
    y1: 50.3662,
    x2: 255.331,
    y2: 51.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_65_324",
    x1: 124.615,
    y1: 59.1152,
    x2: 255.226,
    y2: 59.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_65_324",
    x1: 124.116,
    y1: 68.2888,
    x2: 254.729,
    y2: 69.5946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_65_324",
    x1: 124.62,
    y1: 17.9776,
    x2: 255.232,
    y2: 19.2835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_65_324",
    x1: 124.551,
    y1: 24.9045,
    x2: 255.163,
    y2: 26.2103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_65_324",
    x1: 124.7,
    y1: 41.9608,
    x2: 255.317,
    y2: 42.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_65_324",
    x1: 124.288,
    y1: 51.0929,
    x2: 254.901,
    y2: 52.3988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_65_324",
    x1: 124.901,
    y1: 15.9182,
    x2: 255.511,
    y2: 16.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_65_324",
    x1: 124.461,
    y1: 33.8973,
    x2: 255.073,
    y2: 35.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_65_324",
    x1: 124.72,
    y1: 7.952,
    x2: 255.332,
    y2: 9.25787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_65_324",
    x1: 124.663,
    y1: 13.6028,
    x2: 255.276,
    y2: 14.9086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_65_324",
    x1: 122.673,
    y1: 212.659,
    x2: 253.286,
    y2: 213.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_65_324",
    x1: 122.579,
    y1: 222.078,
    x2: 253.192,
    y2: 223.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_65_324",
    x1: 122.492,
    y1: 230.827,
    x2: 253.104,
    y2: 232.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_65_324",
    x1: 122.404,
    y1: 239.577,
    x2: 253.017,
    y2: 240.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_65_324",
    x1: 123.622,
    y1: 247.82,
    x2: 254.233,
    y2: 248.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_65_324",
    x1: 123.638,
    y1: 256.629,
    x2: 254.249,
    y2: 257.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_65_324",
    x1: 123.532,
    y1: 265.317,
    x2: 254.143,
    y2: 266.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_65_324",
    x1: 122.054,
    y1: 274.576,
    x2: 252.667,
    y2: 275.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_65_324",
    x1: 121.973,
    y1: 282.657,
    x2: 252.586,
    y2: 283.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_65_324",
    x1: 121.901,
    y1: 289.949,
    x2: 252.513,
    y2: 291.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_65_324",
    x1: 123.013,
    y1: 178.633,
    x2: 253.626,
    y2: 179.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_65_324",
    x1: 123.937,
    y1: 186.882,
    x2: 254.547,
    y2: 187.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_65_324",
    x1: 123.892,
    y1: 195.692,
    x2: 254.503,
    y2: 196.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_65_324",
    x1: 122.751,
    y1: 204.882,
    x2: 253.363,
    y2: 206.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_65_324",
    x1: 122.662,
    y1: 213.814,
    x2: 253.274,
    y2: 215.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_65_324",
    x1: 122.562,
    y1: 223.84,
    x2: 253.174,
    y2: 225.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_65_324",
    x1: 122.467,
    y1: 233.319,
    x2: 253.079,
    y2: 234.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_65_324",
    x1: 122.378,
    y1: 242.251,
    x2: 252.99,
    y2: 243.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_65_324",
    x1: 122.292,
    y1: 250.818,
    x2: 252.904,
    y2: 252.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_65_324",
    x1: 122.21,
    y1: 258.96,
    x2: 252.823,
    y2: 260.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_65_324",
    x1: 122.131,
    y1: 266.859,
    x2: 252.744,
    y2: 268.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_65_324",
    x1: 122.052,
    y1: 274.819,
    x2: 252.664,
    y2: 276.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_65_324",
    x1: 121.964,
    y1: 283.569,
    x2: 252.576,
    y2: 284.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_65_324",
    x1: 123.377,
    y1: 142.175,
    x2: 253.99,
    y2: 143.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_65_324",
    x1: 123.273,
    y1: 152.687,
    x2: 253.885,
    y2: 153.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_65_324",
    x1: 124.133,
    y1: 161.001,
    x2: 254.743,
    y2: 161.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_65_324",
    x1: 123.098,
    y1: 170.187,
    x2: 253.71,
    y2: 171.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_65_324",
    x1: 122.843,
    y1: 195.707,
    x2: 253.455,
    y2: 197.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_65_324",
    x1: 122.748,
    y1: 205.125,
    x2: 253.361,
    y2: 206.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_65_324",
    x1: 122.661,
    y1: 213.875,
    x2: 253.273,
    y2: 215.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_65_324",
    x1: 123.758,
    y1: 222.12,
    x2: 254.368,
    y2: 222.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_65_324",
    x1: 122.486,
    y1: 231.374,
    x2: 253.099,
    y2: 232.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_65_324",
    x1: 122.398,
    y1: 240.124,
    x2: 253.011,
    y2: 241.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_65_324",
    x1: 122.311,
    y1: 248.874,
    x2: 252.924,
    y2: 250.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_65_324",
    x1: 122.237,
    y1: 256.287,
    x2: 252.85,
    y2: 257.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_65_324",
    x1: 123.532,
    y1: 126.742,
    x2: 254.145,
    y2: 128.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_65_324",
    x1: 124.207,
    y1: 134.998,
    x2: 254.817,
    y2: 135.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_65_324",
    x1: 123.357,
    y1: 144.181,
    x2: 253.97,
    y2: 145.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_65_324",
    x1: 123.182,
    y1: 161.741,
    x2: 253.795,
    y2: 163.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_65_324",
    x1: 124.028,
    y1: 169.932,
    x2: 254.638,
    y2: 170.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_65_324",
    x1: 124.044,
    y1: 178.741,
    x2: 254.655,
    y2: 179.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_65_324",
    x1: 123.938,
    y1: 187.429,
    x2: 254.548,
    y2: 188.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_65_324",
    x1: 123.892,
    y1: 196.178,
    x2: 254.503,
    y2: 196.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_65_324",
    x1: 123.848,
    y1: 204.926,
    x2: 254.459,
    y2: 205.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_65_324",
    x1: 123.803,
    y1: 213.675,
    x2: 254.413,
    y2: 214.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_65_324",
    x1: 123.758,
    y1: 222.485,
    x2: 254.369,
    y2: 223.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_65_324",
    x1: 123.713,
    y1: 231.112,
    x2: 254.324,
    y2: 231.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_65_324",
    x1: 123.669,
    y1: 239.921,
    x2: 254.28,
    y2: 240.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_65_324",
    x1: 122.309,
    y1: 249.117,
    x2: 252.921,
    y2: 250.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_65_324",
    x1: 123.793,
    y1: 100.796,
    x2: 254.404,
    y2: 102.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_65_324",
    x1: 124.403,
    y1: 108.995,
    x2: 255.014,
    y2: 109.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_65_324",
    x1: 123.617,
    y1: 118.235,
    x2: 254.23,
    y2: 119.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_65_324",
    x1: 123.442,
    y1: 135.796,
    x2: 254.054,
    y2: 137.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_65_324",
    x1: 123.355,
    y1: 144.484,
    x2: 253.967,
    y2: 145.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_65_324",
    x1: 123.267,
    y1: 153.234,
    x2: 253.88,
    y2: 154.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_65_324",
    x1: 123.18,
    y1: 161.984,
    x2: 253.793,
    y2: 163.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_65_324",
    x1: 124.028,
    y1: 170.236,
    x2: 254.639,
    y2: 170.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_65_324",
    x1: 124.043,
    y1: 178.984,
    x2: 254.654,
    y2: 179.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_65_324",
    x1: 123.938,
    y1: 187.672,
    x2: 254.549,
    y2: 188.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_65_324",
    x1: 123.893,
    y1: 196.421,
    x2: 254.504,
    y2: 197.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_65_324",
    x1: 122.65,
    y1: 214.968,
    x2: 253.263,
    y2: 216.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_65_324",
    x1: 123.699,
    y1: 222.776,
    x2: 254.316,
    y2: 223.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_65_324",
    x1: 122.481,
    y1: 231.921,
    x2: 253.093,
    y2: 233.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_65_324",
    x1: 123.964,
    y1: 83.6009,
    x2: 254.576,
    y2: 84.9068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_65_324",
    x1: 124.493,
    y1: 91.801,
    x2: 255.104,
    y2: 92.4848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_65_324",
    x1: 123.79,
    y1: 100.979,
    x2: 254.402,
    y2: 102.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_65_324",
    x1: 123.614,
    y1: 118.539,
    x2: 254.227,
    y2: 119.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_65_324",
    x1: 123.527,
    y1: 127.228,
    x2: 254.14,
    y2: 128.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_65_324",
    x1: 123.149,
    y1: 165.083,
    x2: 253.761,
    y2: 166.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_65_324",
    x1: 124.028,
    y1: 170.479,
    x2: 254.639,
    y2: 171.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_65_324",
    x1: 122.653,
    y1: 214.725,
    x2: 253.265,
    y2: 216.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_65_324",
    x1: 124.136,
    y1: 66.3444,
    x2: 254.749,
    y2: 67.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_65_324",
    x1: 124.568,
    y1: 74.6482,
    x2: 255.185,
    y2: 75.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_65_324",
    x1: 123.959,
    y1: 83.7831,
    x2: 254.574,
    y2: 85.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_65_324",
    x1: 124.387,
    y1: 100.793,
    x2: 254.998,
    y2: 101.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_65_324",
    x1: 123.699,
    y1: 110.032,
    x2: 254.312,
    y2: 111.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_65_324",
    x1: 122.825,
    y1: 197.469,
    x2: 253.438,
    y2: 198.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_65_324",
    x1: 124.307,
    y1: 49.1488,
    x2: 254.921,
    y2: 50.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_65_324",
    x1: 124.613,
    y1: 57.3531,
    x2: 255.223,
    y2: 58.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_65_324",
    x1: 124.136,
    y1: 66.5267,
    x2: 254.747,
    y2: 67.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_65_324",
    x1: 124.478,
    y1: 83.5994,
    x2: 255.088,
    y2: 84.2831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_65_324",
    x1: 124.494,
    y1: 92.3478,
    x2: 255.104,
    y2: 93.0315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_65_324",
    x1: 123.609,
    y1: 119.086,
    x2: 254.221,
    y2: 120.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_65_324",
    x1: 124.314,
    y1: 127.343,
    x2: 254.925,
    y2: 128.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_65_324",
    x1: 123.434,
    y1: 136.525,
    x2: 254.047,
    y2: 137.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_65_324",
    x1: 122.997,
    y1: 180.273,
    x2: 253.61,
    y2: 181.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_65_324",
    x1: 124.376,
    y1: 42.3434,
    x2: 254.989,
    y2: 43.6493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_65_324",
    x1: 124.306,
    y1: 49.3309,
    x2: 254.919,
    y2: 50.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_65_324",
    x1: 124.129,
    y1: 67.0733,
    x2: 254.741,
    y2: 68.3792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_65_324",
    x1: 124.507,
    y1: 75.1951,
    x2: 255.125,
    y2: 75.9177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_65_324",
    x1: 124.478,
    y1: 83.8425,
    x2: 255.089,
    y2: 84.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_65_324",
    x1: 123.685,
    y1: 111.491,
    x2: 254.297,
    y2: 112.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_65_324",
    x1: 124.299,
    y1: 118.837,
    x2: 254.909,
    y2: 119.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_65_324",
    x1: 124.314,
    y1: 127.586,
    x2: 254.925,
    y2: 128.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_65_324",
    x1: 124.209,
    y1: 136.335,
    x2: 254.82,
    y2: 137.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_65_324",
    x1: 123.17,
    y1: 163.017,
    x2: 253.782,
    y2: 164.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_65_324",
    x1: 124.385,
    y1: 41.4927,
    x2: 254.997,
    y2: 42.7986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_65_324",
    x1: 124.312,
    y1: 48.7841,
    x2: 254.924,
    y2: 50.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_65_324",
    x1: 124.629,
    y1: 66.6483,
    x2: 255.24,
    y2: 67.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_65_324",
    x1: 124.524,
    y1: 75.3971,
    x2: 255.134,
    y2: 76.0809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_65_324",
    x1: 123.966,
    y1: 83.3578,
    x2: 254.579,
    y2: 84.6637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_65_324",
    x1: 123.688,
    y1: 111.126,
    x2: 254.301,
    y2: 112.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_65_324",
    x1: 124.299,
    y1: 119.08,
    x2: 254.91,
    y2: 119.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_65_324",
    x1: 124.254,
    y1: 127.829,
    x2: 254.865,
    y2: 128.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_65_324",
    x1: 124.21,
    y1: 136.578,
    x2: 254.82,
    y2: 137.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_65_324",
    x1: 123.341,
    y1: 145.821,
    x2: 253.954,
    y2: 147.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_65_324",
    x1: 124.703,
    y1: 40.7065,
    x2: 255.314,
    y2: 41.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_65_324",
    x1: 124.324,
    y1: 47.5687,
    x2: 254.936,
    y2: 48.8745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_65_324",
    x1: 124.189,
    y1: 61.0579,
    x2: 254.801,
    y2: 62.3638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_65_324",
    x1: 124.629,
    y1: 66.8913,
    x2: 255.24,
    y2: 67.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_65_324",
    x1: 124.524,
    y1: 75.701,
    x2: 255.135,
    y2: 76.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_65_324",
    x1: 123.687,
    y1: 111.308,
    x2: 254.299,
    y2: 112.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_65_324",
    x1: 124.299,
    y1: 119.384,
    x2: 254.91,
    y2: 120.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_65_324",
    x1: 123.514,
    y1: 128.565,
    x2: 254.127,
    y2: 129.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_65_324",
    x1: 124.453,
    y1: 34.6874,
    x2: 255.065,
    y2: 35.9932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_65_324",
    x1: 124.699,
    y1: 40.9887,
    x2: 255.316,
    y2: 41.7114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_65_324",
    x1: 124.209,
    y1: 58.9923,
    x2: 254.822,
    y2: 60.2981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_65_324",
    x1: 124.63,
    y1: 67.1953,
    x2: 255.241,
    y2: 67.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_65_324",
    x1: 124.524,
    y1: 75.9443,
    x2: 255.135,
    y2: 76.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_65_324",
    x1: 123.983,
    y1: 81.6562,
    x2: 254.595,
    y2: 82.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_65_324",
    x1: 123.686,
    y1: 111.369,
    x2: 254.299,
    y2: 112.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_65_324",
    x1: 124.47,
    y1: 32.9859,
    x2: 255.082,
    y2: 34.2918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_65_324",
    x1: 124.399,
    y1: 40.0343,
    x2: 255.012,
    y2: 41.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_65_324",
    x1: 124.27,
    y1: 52.9766,
    x2: 254.882,
    y2: 54.2825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_65_324",
    x1: 124.615,
    y1: 58.7506,
    x2: 255.225,
    y2: 59.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_65_324",
    x1: 124.631,
    y1: 67.4381,
    x2: 255.241,
    y2: 68.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_65_324",
    x1: 124.525,
    y1: 76.1871,
    x2: 255.135,
    y2: 76.8708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_65_324",
    x1: 123.858,
    y1: 94.1735,
    x2: 254.47,
    y2: 95.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_65_324",
    x1: 124.537,
    y1: 26.2413,
    x2: 255.149,
    y2: 27.5472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_65_324",
    x1: 124.467,
    y1: 33.229,
    x2: 255.08,
    y2: 34.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_65_324",
    x1: 124.292,
    y1: 50.7285,
    x2: 254.905,
    y2: 52.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_65_324",
    x1: 124.615,
    y1: 58.9936,
    x2: 255.225,
    y2: 59.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_65_324",
    x1: 124.631,
    y1: 67.7419,
    x2: 255.241,
    y2: 68.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_65_324",
    x1: 124.03,
    y1: 76.9169,
    x2: 254.643,
    y2: 78.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_65_324",
    x1: 124.795,
    y1: 24.3635,
    x2: 255.406,
    y2: 25.0472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_65_324",
    x1: 124.495,
    y1: 30.434,
    x2: 255.108,
    y2: 31.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_65_324",
    x1: 124.376,
    y1: 42.2824,
    x2: 254.989,
    y2: 43.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_65_324",
    x1: 124.721,
    y1: 50.4877,
    x2: 255.332,
    y2: 51.1714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_65_324",
    x1: 124.202,
    y1: 59.7213,
    x2: 254.815,
    y2: 61.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_65_324",
    x1: 124.636,
    y1: 16.3373,
    x2: 255.249,
    y2: 17.6432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_65_324",
    x1: 124.562,
    y1: 23.7503,
    x2: 255.175,
    y2: 25.0561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_65_324",
    x1: 124.449,
    y1: 34.9909,
    x2: 255.062,
    y2: 36.2968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_65_324",
    x1: 124.375,
    y1: 42.465,
    x2: 254.988,
    y2: 43.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_65_324",
    x1: 124.714,
    y1: 8.55956,
    x2: 255.326,
    y2: 9.86542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_65_324",
    x1: 124.634,
    y1: 16.5194,
    x2: 255.247,
    y2: 17.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_65_324",
    x1: 123.003,
    y1: 179.726,
    x2: 253.615,
    y2: 181.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1215,
    height: 295,
    fill: "white",
    transform: "translate(0.146973 0.604004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShieldTrustnet);
export default __webpack_public_path__ + "static/media/logo_shield_trustnet.315baa73835659a7c1a0fc53f170b782.svg";
export { ForwardRef as ReactComponent };